export default "__VITE_ASSET__BcTzmUlS__"